export class DamageEstimationBase {
    description;
    operation = 'replace';
    operation_user;
    paint_materials = 0;
    labour_time = 0;
    paint_time = 0;
    part_price = 0;
    strip_assembly = 0;
    part_provider = undefined;
    part_reference = undefined;
    value;
    constructor(base = {}) {
        Object.entries(base).forEach(([key, value]) => {
            this[key] = value ?? this[key];
        });
    }
}
